import React from 'react'
import { useForm } from 'react-hook-form'
import { ConnectedProps } from 'react-redux'
import TextareaAutosize from 'react-textarea-autosize'
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { Edit, Pane } from '_components'
import { userConnector } from '_store'
import { SOL_WEB_URL } from '_utils/config'

type Brand = {
    description?: string;

    websiteUrl?: string;
    email?: string;
    phone?: string;
    address?: string;

    facebookUrl?: string;
    instagramUrl?: string;
    twitterUrl?: string;
    youtubeUrl?: string;
}

const EditBrandForm: React.FC<{ data: Brand; onSubmit: (brand: Brand) => void; }> = ({ data, onSubmit }) => {
    const { register, handleSubmit } = useForm<Brand>({ defaultValues: data })

    const Textarea: React.FC<{ label: string; name: string, placeholder?: string}> = ({ label, ...props}) => <div className="form-group">
        <label>{label}</label>
        <TextareaAutosize {...props} className="form-control" ref={register()} />
    </div>

    const Input: React.FC<{ label: string, name: string }> = ({ label, ...props }) => <div className="form-group">
        <label>{label}</label>
        <input {...props} className="form-control" ref={register()} />
    </div>

    return <form onSubmit={handleSubmit(onSubmit)}>
        <Textarea name="description" label="Description" placeholder="Describe your company here." />

        <Input name="websiteUrl" label="Website URL" />
        <Input name="email" label="E-mail address" />
        <Input name="phone" label="Phone number" />
        <Textarea name="address" label="Address" />
        
        <Input name="facebookUrl" label="Facebook URL" />
        <Input name="instagramUrl" label="Instagram URL" />
        <Input name="twitterUrl" label="Twitter URL" />
        <Input name="youtubeUrl" label="YouTube URL" />

        <input type="submit" className="btn btn-primary" value="Save" />
    </form>
}

const BrandPreviewButton: React.FC<{handle: string}> = ({ handle }) => <a href={`${SOL_WEB_URL}/brand/${handle}`} target="_blank" rel="noopener noreferrer">
    <button className='btn btn-primary'>
        <FontAwesomeIcon icon={faExternalLinkAlt} /> Preview
    </button>
</a>

const PAccount: React.FC<ConnectedProps<typeof userConnector>> = ({ user }) => <Pane>
    <h1>Account</h1>
    <p>This account is registered to {user!.manufacturer.companyName}.</p>
    <p>Your dedicated advisor is Sebastian Kurella (<a href="mailto:sebastian.kurella@soltag.info">sebastian.kurella@soltag.info</a>).</p>
    <p>To change your brand-related data (name, logo, etc.), please drop us an email at <a href="mailto:contact@soltag.info">contact@soltag.info</a>.</p>
    <h1>Brand profile</h1>
    <div style={{display: 'flex', flexFlow: 'row nowrap', alignItems: 'baseline'}}>
        <p>All information entered here is publicly available.</p>
        &emsp;  
        <BrandPreviewButton handle={user!.manufacturer.handle} />
    </div>
    
    <Edit<Brand> endpoint="/brand" Form={EditBrandForm} />
</Pane>

export const Account = userConnector(PAccount)
